import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { ModalPrivacyPolicyComponent } from '../modal-privacy-policy/modal-privacy-policy.component';

@Component({
  selector: 'app-modal-preferences',
  templateUrl: './modal-preferences.component.html',
  styleUrls: ['./modal-preferences.component.scss']
})
export class ModalPreferencesComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalPreferencesComponent>
  ) { }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  openDialogPrivacyPolicy() {

    this.closeModal()
    this.dialog.open(ModalPrivacyPolicyComponent);
  }

}
